/* eslint-disable react/no-danger */
import { showNextProject } from "../core/project/projectdata";
import { CONTENT_VIEW_NAME, NEXT_PROJECT_BUTTON } from "../core/constants";
import { NextProjectButton } from "../components/buttons/NextProjectButton";
import { getDomainCfg, store } from "../core/state";
import { useEffect, useState } from "react";
import { getRedirectUrl, redirectTo } from "../features/redirect";
import { nextQueryWaypoint, unlockQuest } from "../features/stats";
import { getAppCfg } from "../core/app-cfg";

export function ContentView() {
  const [showNextProjectButton, setShowNextProjectButton] = store.useState(NEXT_PROJECT_BUTTON, { default : false});
  const [contentState] = store.useState(CONTENT_VIEW_NAME);
  const [activeDelay, setActiveDelay] = useState(false);

  useEffect(() => {
    if (!activeDelay && (contentState.project?.nextProject || contentState.project?.completesQuestStep)) {
      setActiveDelay(true);
      const handle = setTimeout(() => {
        console.log("EditorNavMenu: show next project button");
        setShowNextProjectButton(true);
      }, 400);
  
      // Aufräumen der useEffect-Funktion
      return () => clearTimeout(handle);
    }
  }, [activeDelay, contentState.project]);

  const nextProjectRequested = async () => {
    setShowNextProjectButton(false);

    if (contentState.project?.unlocksQuest) {
      unlockQuest(contentState.project.unlocksQuest);
    }

    if (!contentState.project?.nextProject && !contentState.project?.completesQuestStep) {
      redirectTo(getRedirectUrl(getDomainCfg().viewSettings.projectsView));
      return;
    }
    
    if (contentState.project?.completesQuestStep) {
      await nextQueryWaypoint(contentState.project?.completesQuestStep, getAppCfg().projectId);
      redirectTo(
        getRedirectUrl(getDomainCfg().viewSettings.questView, contentState.project?.completesQuestStep, "quest")
      );
      return;
    }
    setTimeout(() => {      
      showNextProject(contentState.project?.nextProject);
    }, 500);
  }

  
  return <div className="story-content">    
    <div dangerouslySetInnerHTML={{ __html: contentState.data }} />
    <NextProjectButton nextProjectRequested={nextProjectRequested} show={showNextProjectButton} floating={true} />
    <div id="content-bottom" />
  </div>;
}
